<template lang="pug">
  .home
    //- sticker
    sticker
    //- collections
    collection(:collections="collections", v-if="collections")
</template>

<script>
import Collection from '@/views/Collection'
import Sticker from '@/components/Sticker'
import get from 'lodash/get'
export default {
  name: 'Home',
  computed: {
    doc () {
      return this.$store.state.pages['home']
    },
    collections () {
      const cols = get(this.doc, 'acf.product_collections')
      return cols && cols.map(col => col.shopify_collection_id)
    }
  },
  created () {
    this.$store.dispatch('getPage', 'home')
  },
  components: { Collection, Sticker }
}
</script>
